<template>
	<transition name="lightbox">
		<div class="lightbox" v-if="openModal">
			<div class="inner">
				<v-loader></v-loader>
				<v-image :src="src" @click.native="close()"></v-image>
				<span class="close" @click="close()">
					<svg
						aria-hidden="true"
						focusable="false"
						data-prefix="fas"
						data-icon="times"
						class="svg-inline--fa fa-times fa-w-11"
						role="img"
						xmlns="http://www.w3.org/2000/svg"
						viewBox="0 0 352 512"
					>
						<path
							fill="currentColor"
							d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
						/>
					</svg>
				</span>
			</div>
		</div>
	</transition>
</template>

<script>
import vImage from "./responsive-image.vue";
import vLoader from "./loader.vue";

export default {
	props: {
		openModal: { required: true, type: Boolean },
		src: { required: false, type: String },
		download: { required: false, type: String }
	},
	components: {
		vImage,
		vLoader
	},
	methods: {
		close: function() {
			this.$emit("close");
		}
	}
};
</script>

<style lang="scss" scoped>
.lightbox {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background: $white;
	overflow-y: scroll;
	z-index: 15;

	.inner {
		position: relative;
		max-width: 1440px;
		margin-left: auto;
		margin-right: auto;
		padding-left: 40px;
		padding-right: 40px;
		display: flex;
		min-height: 100%;
		align-items: center;
		justify-content: center;

		::v-deep .loader-container {
			position: absolute;
			z-index: 1;
		}

		::v-deep img {
			max-width: 100%;
			cursor: zoom-out;
			z-index: 2;
		}

		.close,
		.download {
			position: absolute;
			width: 24px;
			height: 24px;
			display: block;
			cursor: pointer;
			top: 25px;

			svg {
				width: 100%;
				height: 100%;
				fill: $medium-grey;
			}
		}

		.close {
			right: 0;
		}

		.download {
			right: -25px;
		}
	}

	&-enter-active,
	&-leave-active {
		transition: opacity 0.3s ease-in-out;
	}
	&-enter,
	&-leave-to {
		opacity: 0;
	}
}
</style>
